"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const msal_browser_1 = require("@azure/msal-browser");
const msal_config_1 = require("./configs/msal-config");
class EkcPCA {
    constructor(pcaAuthOptions, pcaScopes = []) {
        this.pcaAuthOptions = pcaAuthOptions;
        this.pcaScopes = pcaScopes;
        this.pca = new msal_browser_1.PublicClientApplication((0, msal_config_1.msalConfig)(this.pcaAuthOptions));
        const accounts = this.pca.getAllAccounts();
        if (accounts.length > 0) {
            this.pca.setActiveAccount(accounts[0]);
        }
        this.pca.addEventCallback((event) => {
            if (event.eventType === msal_browser_1.EventType.LOGIN_SUCCESS && event.payload) {
                const payload = event.payload;
                const account = payload.account;
                this.pca.setActiveAccount(account);
            }
        });
    }
    /////////////////////////////////////////////////////////////////////////////
    login({ mode, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (mode === 'popup') {
                const response = yield this.pca.loginPopup({
                    scopes: this.pcaScopes,
                });
                return response.account;
            }
            else
                throw new Error('redirect mode is not implemented!');
        });
    }
    logout({ mode }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (mode === 'popup') {
                return yield this.pca.logoutPopup({
                    account: this.pca.getActiveAccount(),
                });
            }
            else
                throw new Error('redirect mode is not implemented!');
        });
    }
    acquireTokenSilent() {
        return __awaiter(this, void 0, void 0, function* () {
            const msalAccount = this.pca.getActiveAccount();
            if (!msalAccount)
                return null;
            const msalResponse = yield this.pca.acquireTokenSilent({
                scopes: this.pcaScopes,
                account: msalAccount !== null && msalAccount !== void 0 ? msalAccount : undefined,
            });
            return msalResponse === null || msalResponse === void 0 ? void 0 : msalResponse.accessToken;
        });
    }
    /////////////////////////////////////////////////////////////////////////////
    getAccount() {
        return this.pca.getActiveAccount();
    }
}
exports.default = EkcPCA;
